.root {
  white-space: pre-line;
  vertical-align: baseline;
}

.more {
  color: var(--palettePrimary2);

  &:hover {
    color: var(--palettePrimary0);
  }
}

.sameLine {
  margin-left: 10px;
}
